function labnolThumbCarousel(img, video) {
   var thumb = '<img class="img-fluid w-100" loading="lazy" src="IMGURL">',
      play = '<div id="' + video + '" class="oe-modal__button-play play"></div>';
   return thumb.replace("IMGURL", img) + play;
}

function labnolIframeCarousel(id) {
   var iframe = document.createElement("iframe");
   var embed =
      "https://www.youtube.com/embed/ID?autoplay=1&wmode=transparent&rel=0&mute=1&controls=1&version=3&enablejsapi=1";
   iframe.setAttribute("src", embed.replace("ID", id));
   iframe.setAttribute("frameborder", "0");
   iframe.setAttribute("allowfullscreen", "1");
   iframe.setAttribute("allow", "autoplay");
   iframe.setAttribute("id", "youtube-video");
   iframe.setAttribute("class", "w-100");
   iframe.setAttribute("height", "350");
   document.getElementById("youtube-video").replaceWith(iframe);
}

function video(dataid) {
   var videoIframe = labnolThumbCarousel("https://img.youtube.com/vi/" + dataid + "/hqdefault.jpg", dataid);
   document.getElementById("youtube-video").innerHTML = videoIframe;
   var tempDoc = document.getElementById(dataid);
   tempDoc.addEventListener("click", function (event) {
      labnolIframeCarousel(dataid);
   });
}

function myClose() {
   var elms = document.querySelectorAll("[id='youtube-video']");

   for (var i = 0; i < elms.length; i++) {
      elms[i].contentWindow.postMessage('{"event":"command","func":"' + "stopVideo" + '","args":""}', "*");
   }
}
document.querySelectorAll(".video-testimonial__button").forEach((videoClick) => {
   videoClick.addEventListener("click", function (event) {
      let currentData = videoClick.getAttribute("data-video");
      let videoPop = document.getElementById("youtube-video");
      videoPop.setAttribute("data-id", currentData);
      labnolIframeCarousel(currentData);
   });
});

const el = document.querySelector("#carousel-video");
if (el) {
   el.addEventListener("hidden.bs.modal", function () {
      myClose();
      document.getElementById("videocontentcarou").innerHTML =
         '<div class="youtube-player oe-modal__wrapper-youtube-player" id="youtube-video" data-id="XaOSS_4DYP0"></div>';
   });
}
